import { FC } from 'react';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

export const EditorComponentPageLoader: FC = () => {
  return (
    <Box>
      <Skeleton variant="rect" height="50vh" />
    </Box>
  );
};
